import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import MapMarker from 'react-icons/fa/map-marker'
import Close from 'react-icons/fa/times-circle'

import TwitterIcon from 'react-icons/fa/twitter'
import GlobeIcon from 'react-icons/fa/globe'

import SchoolFollow from './SchoolFollow'
import './SchoolCelebrationHeader.css'

import TopNavigation from '../../shared/TopNavigation.js'
import Modal from 'react-modal'
import FaClose from 'react-icons/fa/times-circle'
import { withMe } from 'pobble-components/dist/pobble-user'


@autobind
class SchoolHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      followedSchools: this.props.me && this.props.me.account && this.props.me.account.followed_schools || []
    }
  }

  handleOpenModal (e) {
    e.preventDefault()
    this.setState({showModal: true})
  }

  handleCloseModal () {
    this.setState({showModal: false})
  }

  render () {
    const cover = this.props.background_image_url && <div styleName='cover' style={{backgroundImage: `url(${this.props.background_image_url})`}} />
    const logo = this.props.logo_url && <div styleName='logo' style={{backgroundImage: `url(${this.props.logo_url})`}} />

    const school = <section styleName='container'>
      <div styleName='badge'>
        <div>
          <div styleName='title'>{this.props.title}</div>
          {(this.props.city || this.props.country) && <div styleName='location'>
            <MapMarker />{this.props.city}{this.props.country ? ', ' + this.props.country : ''}
          </div>}
          <div styleName='description'>
            {this.props.twitter_handler && <span><TwitterIcon /> <a href={`https://twitter.com/${this.props.twitter_handler}`} target='_blank' rel='noreferrer noopener'>{this.props.twitter_handler}</a></span>}
            {this.props.website && <span><GlobeIcon /> <a href={this.props.website} target='_blank' rel='noreferrer noopener'>{this.props.website}</a></span>}
            </div>
          <div styleName='description'>{this.props.description}</div>
          <div styleName='stats'>
            <div><span>{this.props.number_of_works_views}</span>Views</div>
            <div><span>{this.props.number_of_published_works}</span>Works</div>
            <div><span>{this.props.number_of_published_works_authors}</span>Authors</div>
          </div>
        </div>
        {logo}
      </div>

      {/*<div styleName='top'>
        <button className='btn' onClick={e => this.handleOpenModal(e, 0)}>Schools I follow</button>
        <label htmlFor='searchInput'>Search for a school</label>
        {this.props.user && <SchoolFollow schoolId={this.props.id} user={this.props.user} isFollowing={this.props.followed_by_current_account} onFollow={this.props.onFollow} />}
      </div>*/}
      {cover}
    </section>

  let followedSchools = this.state.followedSchools && this.state.followedSchools.map((school, index) =>
      (school && school.id && <li key={index}>
        <Link to={{pathname: `/schools/${school.id}`}} onClick={this.handleCloseModal}>
          {school.title}
        </Link></li>))

    return (
      <div>
        <TopNavigation selected="school" />
        {this.props.id && <div>
          {school}
        </div>}
        <Modal isOpen={this.state.showModal} contentLabel='Followed schools' onRequestClose={this.handleCloseModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <div className='modal-dialog modal-dialog--small'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h4 className='modal-title'>Schools I follow</h4>
                <span className='modal__close' onClick={this.handleCloseModal}>
                  <FaClose />
                </span>
              </div>
              <ul styleName='followedSchools'>
                {followedSchools}
              </ul>
              {this.state.followedSchools && !this.state.followedSchools.length && <div className='modal-body'>
                <p>No schools followed yet.</p>
              </div>}
              <div className='modal-footer'>
                <button className='btn btn-primary' onClick={this.handleCloseModal}>Close</button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

SchoolHeader.propTypes = {
  bg_image: PropTypes.object,
  city: PropTypes.string,
  closeSchool: PropTypes.func,
  comments_count: PropTypes.number,
  country: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  authors_count: PropTypes.number,
  logo: PropTypes.object,
  title: PropTypes.string,
  views_count: PropTypes.number,
  user: PropTypes.object,
  onFollow: PropTypes.func
}

export default withMe(SchoolHeader)



// WEBPACK FOOTER //
// ./components/search/SchoolCelebrationHeader.js